import createIcon from '../../createIcon';

/**
 * @component @name Headset
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMi41QzcuMDMgMi41IDMgNi41MyAzIDExLjVWMTguNUMzIDIwLjE2IDQuMzQgMjEuNSA2IDIxLjVIOVYxMy41SDVWMTEuNUM1IDcuNjMgOC4xMyA0LjUgMTIgNC41QzE1Ljg3IDQuNSAxOSA3LjYzIDE5IDExLjVWMTMuNUgxNVYyMS41SDE4QzE5LjY2IDIxLjUgMjEgMjAuMTYgMjEgMTguNVYxMS41QzIxIDYuNTMgMTYuOTcgMi41IDEyIDIuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Headset = createIcon('Headset', [
  [
    'path',
    {
      d: 'M12 2.5C7.03 2.5 3 6.53 3 11.5V18.5C3 20.16 4.34 21.5 6 21.5H9V13.5H5V11.5C5 7.63 8.13 4.5 12 4.5C15.87 4.5 19 7.63 19 11.5V13.5H15V21.5H18C19.66 21.5 21 20.16 21 18.5V11.5C21 6.53 16.97 2.5 12 2.5Z',
      key: '14cali',
    },
  ],
]);

export default Headset;
